/**
 * Returns the actions map for WLS dashboards. Each dashboard passes its own
 * status -> components map (Continue, CancelOrder, View, Locked from local Actions).
 * @param {Object} actionsRest - Map of status key to array of action components
 * @returns {Object} actionsRest (for use with _.get(actionsRest, status, []))
 */
export const createActionsRest = actionsRest => actionsRest;
